import { useEffect, useState } from "react";
// @constants
import { STATUSES } from "../constants/bringAccountConstants";
// @helpers
import { taggingIbanError } from "../helpers/bringAccountTagging";
import { getIbanMessageError } from "../helpers/bringAccountHelper";

export const useSettingTransferStep = ({ immBringAccount, immProfile, actions }) => {
    const [ibanError, setIbanError] = useState(null)

    const ibanState = immBringAccount.get('iban');
    const entityState = immBringAccount.get('entity');
    const executionDate = immBringAccount.get('executionDate');
    const countryCode = immProfile.get('originCountry');
    const ibanNumber = ibanState.get('number');

    const getIbanValidation = () => {
        const { isDirty, isValid, exists } = ibanState.toJS();

        return {
            isValidIban: isDirty && isValid,
            existsIban: isDirty && exists,
            hasErrorIban: isDirty && (!isValid || !exists),
        }
    };

    const getEntityState = () => {
        const { status, bank_name: bankName } = entityState.toJS();
        return {
            isIDLE: status === STATUSES.IDLE,
            isVisibleEntitySection: status !== STATUSES.IDLE && status !== STATUSES.ERROR,
            isLoadingEntity: status === STATUSES.FETCHING,
            isFetchedEntity: status === STATUSES.FETCHED,
            entityName: bankName,
        };
    }

    useEffect(() => {
        const { isValidIban, existsIban }  = getIbanValidation()
        const { isIDLE } = getEntityState();

        if (!isValidIban || !existsIban) {
            const ibanError = getIbanMessageError({ isValidIban, existsIban });
            setIbanError(ibanError);
            taggingIbanError({ isValidIban, existsIban, ibanMessageError: ibanError });
        }

        if (isValidIban && existsIban && isIDLE) {
            actions.getEntityName(ibanNumber);
        }
    }, [ibanState, entityState]);

    return {
        ibanNumber,
        executionDate,
        countryCode,
        ibanError,
        getIbanValidation,
        getEntityState,
    };
}
